module.exports = __webpack_public_path__ + "static/media/cross.fde313d2.svg";